import {
  ATTACHMENT_UPLOAD_STATUS,
  CONVERSION_STATUS,
} from './AssignmentAttachmentContext';
import { getAttachmentGeneralFileType } from './attachment.utils';

const useSubmissionControlButtons = ({
  assignment,
  attachment,
  conversionStatus,
  uploadStatus,
  isUpdatingCommentCompleted,
}) => {
  const isSubmitButtonDisabled = assignment.attachmentRequired
    ? !attachment ||
      ((conversionStatus === CONVERSION_STATUS.timedOut &&
        getAttachmentGeneralFileType(attachment) !== 'document') ||
        conversionStatus === CONVERSION_STATUS.inProgress)
    : !isUpdatingCommentCompleted;

  const isSaveButtonDisabled =
    uploadStatus === ATTACHMENT_UPLOAD_STATUS.inProgress ||
    (attachment &&
      (conversionStatus === CONVERSION_STATUS.inProgress ||
        (conversionStatus === CONVERSION_STATUS.timedOut &&
          getAttachmentGeneralFileType(attachment) !== 'document'))) ||
    (!isUpdatingCommentCompleted && !attachment);

  return {
    isSubmitButtonDisabled,
    isSaveButtonDisabled,
  };
};

export default useSubmissionControlButtons;
